// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"bfb0c672","125":"9d5c4ba5","342":"ab08f7e6","585":"35062c7b","647":"389445c8","867":"9d5c4ba5","893":"bd4b1d23","994":"4ceb8f80"}[chunkId] + ".css";
};